<div class="col-sm-12">

    <h3>Atualizar proposta de parceria</h3>
    <hr>

    <div class="col-sm-12">

        <ul class="timeline">

            <li class="time-label">
                <span class="bg-red">Etapa 1</span>
            </li>
            <li>
                <i class="fa fa-clone bg-blue"></i>
                <div class="timeline-item">

                    <h3 class="timeline-header">
                        <a (click)="openEtapa1()" style="cursor: pointer;">1 - CONCEDENTE, TÍTULO E DESCRIÇÃO</a>
                    </h3>

                    <div class="timeline-body" *ngIf="etapa1">

                        <div class="col-sm-12">

                            <div class="ui-g-12 ui-fluid no-padding">
                                <label>Entidade Concedente:</label>
                                <p-select name="entidadeConcedente" [options]="entidadesConcedente"
                                    placeholder="Selecione" [filter]="true"
                                    [(ngModel)]="dispensaInexigibilidade.entidadeConcedente.id"
                                    (onChange)="entidadeSelecionada()" required></p-select>
                            </div>

                            <div class="col-sm-12 no-padding">
                                <br>
                                <label>Título:</label>
                                <input type="text" name="titulo" [(ngModel)]="dispensaInexigibilidade.titulo"
                                    class="form-control">
                            </div>

                            <div class="col-sm-12 no-padding">
                                <br>
                                <label>Descrição:</label>
                                <p-editor [(ngModel)]="dispensaInexigibilidade.descricao">
                                </p-editor>
                            </div>

                        </div>

                    </div>

                    <div class="timeline-footer" *ngIf="etapa1">

                        <a class="btn btn-primary btn-sm" (click)="openEtapa2()">Próximo</a>
                    </div>
                </div>
            </li>


            <li class="time-label">
                <span class="bg-red">Etapa 2</span>
            </li>
            <li>
                <i class="fa fa-clone bg-blue"></i>
                <div class="timeline-item">

                    <h3 class="timeline-header">
                        <a (click)="openEtapa2()" style="cursor: pointer;">2 – ORÇAMENTO DO PROJETO </a>
                    </h3>

                    <div class="timeline-body" *ngIf="etapa2">



                        <div class="form-group col-sm-3">
                            <label>Valor:</label>
                            <input type="text" name="name" [(ngModel)]="planoTrabalho.et2Valor" class="form-control"
                                placeholder="R$ 0.000,00" currencyMask
                                [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left' }">
                        </div>
                        <div class="form-group col-sm-9">
                            <label>Valor por extenso:</label>
                            <input type="text" name="name" [(ngModel)]="planoTrabalho.et2ValorExtenso"
                                class="form-control">
                        </div>



                    </div>

                    <div class="timeline-footer" *ngIf="etapa2">
                        <a class="btn btn-primary btn-sm" (click)="openEtapa1()">Voltar</a>
                        <a class="btn btn-primary btn-sm" (click)="openEtapa3()">Próximo</a>
                    </div>
                </div>
            </li>


            <li class="time-label">
                <span class="bg-red">Etapa 3</span>
            </li>
            <li>
                <i class="fa fa-clone bg-blue"></i>
                <div class="timeline-item">

                    <h3 class="timeline-header">
                        <a (click)="openEtapa3()" style="cursor: pointer;">3 – ANEXOS DA PROPOSTA</a>
                    </h3>

                    <div class="timeline-body" *ngIf="etapa3">



                        <label>Anexar arquivo: </label>
                        <a class="btn btn-primary btn-sm" (click)="openModalUpload('parceria')">
                            <i class="fa fa-paperclip"></i>
                        </a>

                        <hr *ngIf="dataUploadArray.length">

                        <table class="table" *ngIf="dataUploadArray.length">
                            <thead>
                                <tr>
                                    <th width="50%">Nome arquivo</th>
                                    <th>Tamanho</th>
                                    <th class="text-center">Remover</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of dataUploadArray">
                                    <td>
                                        <strong>{{ item.originalname }}</strong>
                                    </td>
                                    <td nowrap>{{ item.size/1024/1024 | number:'.2' }} MB</td>
                                    <td class="text-center">
                                        <span>
                                            <i class="glyphicon glyphicon-remove cursor"
                                                (click)="removeFileProposta(item, 'parceria')"></i>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>

                    <div class="timeline-footer" *ngIf="etapa3">
                        <a class="btn btn-primary btn-sm" (click)="openEtapa2()">Voltar</a>
                        <a class="btn btn-primary btn-sm" (click)="openEtapa4()">Próximo</a>
                    </div>
                </div>
            </li>

            <li class="time-label">
                <span class="bg-red">Etapa 4</span>
            </li>
            <li>
                <i class="fa fa-clone bg-blue"></i>
                <div class="timeline-item">

                    <h3 class="timeline-header">
                        <a (click)="openEtapa4()" style="cursor: pointer;">4 – CONFIRMAR CADASTRO</a>
                    </h3>

                    <div class="timeline-body" *ngIf="etapa4">
                        <p><span style="color: #999;">Entidade concedente:</span><b> {{ nomeConcedente }} </b> </p>
                        <p><span style="color: #999;">Tipo de processo:</span><b> {{ retornaTipoProposta() }}</b> </p>
                        <p><span style="color: #999;">Título:</span> <b>{{ dispensaInexigibilidade.titulo }}</b></p>
                        <hr>
                        <span style="color: #999;">
                            <p>Descrição:</p>
                        </span>
                        <div [innerHtml]="dispensaInexigibilidade.descricao"></div>

                        <hr>
                        <p><span style="color: #999;">Valor:</span><b>
                                {{ planoTrabalho.et2Valor | currency: 'BRL':'symbol-narrow':'1.2-2' }} </b> </p>
                        <p><span style="color: #999;">Valor por extenso: </span><b> {{ planoTrabalho.et2ValorExtenso }}
                            </b> </p>
                        <hr>
                        <p><span style="color: #999;">Links dos Anexos: </span></p>
                        <div *ngFor="let anexo of dataUploadArray">
                            <a style="cursor: pointer;" (click)="openModalAnexo(anexo)"> {{anexo.originalname}}</a>
                        </div>

                    </div>

                    <div class="timeline-footer" *ngIf="etapa4">
                        <a class="btn btn-primary btn-sm" (click)="openEtapa3()">Voltar</a>
                        <a class="btn btn-success btn-sm" (click)="salvar()">SALVAR</a>
                    </div>
                </div>
            </li>



        </ul>

    </div>

</div>



<!--MODAIS-->
<p-dialog [(visible)]="openModalViewUpload" width="700" showEffect="fade" [modal]="true">

    <div class="col-sm-12">
        <h3>Upload de arquivos.</h3>

        <button type="button" class="btn btn-success  btn-sm" (click)="adicionarArquivo()">
            <i class="fa fa-fw fa-save"></i> Salvar
        </button>

        <hr>
    </div>

    <div class="col-sm-12">
        <app-upload-service></app-upload-service>
        <hr>
    </div>

</p-dialog>

<p-dialog [style]="{width: '800px'}" header="{{nomeAnexo}}" [(visible)]="displayAnexo" showEffect="fade" [modal]="true"
    [baseZIndex]="10000">

    <div class="col-sm-12">
        <h3>Anexo</h3>
        <hr>
    </div>

    <div class="col-sm-12 text-center">
        <hr>
        <div class="embed-container" *ngIf="viewDownload">

            <div class="myIframe">
                <iframe [src]="urlDocumento | safe" frameborder='0'></iframe>
            </div>

        </div>

    </div>

</p-dialog>